module.exports = __webpack_public_path__ + "static/media/B1.00dc70cf.jpg";